import { Autocomplete, Button, Modal, TextField } from "@mui/material";
import classNames from "classnames";

const CustomModal = ({
  open,
  setOpen,
  onClose,
  children,
  onClick,
  loading,
  title,
  button,
  width,
  color,
  className,
}) => {
  const handleClose = (e) => {
    if (e) {
      e.stopPropagation?.();
      e.preventDefault?.();
    }
    if (typeof onClose === "function") {
      onClose();
    } else if (typeof setOpen === "function") {
      setOpen(false);
    }
  };

  return (
    <Modal
      open={Boolean(open)}
      onClose={handleClose}
      disableEscapeKeyDown={false}
    >
      <div
        className={classNames(
          `w-[95%] max-h-[95dvh] overflow-y-auto border-2 border-black rounded-lg py-8 px-6 flex flex-col gap-6
            top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 absolute shadow-2xl z-50 focus:outline-none`,
          color === true ? "bg-pink-200" : "bg-[#fff685]",
          width ? width : "md:w-[35rem]",
          className
        )}
      >
        <div className="flex items-center justify-between border-b pb-2 border-black">
          <h2 className="text-2xl font-semibold">{title}</h2>
          <button
            type="button"
            aria-label="Close"
            onClick={handleClose}
            className="p-1 -mr-1 rounded-md text-red-500 hover:text-white hover:bg-red-500 transition cursor-pointer flex items-center justify-center"
            title="Close"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-7 w-7 pointer-events-none"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2.5}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div className="flex flex-col gap-4">{children}</div>

        <div className="flex items-end justify-end">
          {button ? (
            button
          ) : (
            <Button
              variant="contained"
              color="primary"
              className="w-1/3"
              onClick={onClick}
            >
              {loading ? "Loading..." : "Save"}
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default CustomModal;

export const ModalInput = ({
  title,
  onChange,
  bg,
  value,
  disabled,
  width,
  type,
}) => {
  return (
    <div className="flex gap-1 md:gap-3 md:items-center flex-col md:flex-row justify-between">
      {title && <label htmlFor={title} className="font-medium">{title}</label>}
      <input
        onChange={onChange}
        type={type ? type : "text"}
        name={title}
        id={title}
        className={`${bg ? "bg-gray-100" : "bg-white"} border-2 ${
          width ? width : "md:w-64"
        } border-black py-1 px-2 rounded`}
        value={value}
        disabled={disabled}
      />
    </div>
  );
};

export const ModalSelect = ({ title, options, onChange, bg, value, width }) => {
  return (
    <div className="flex gap-3 flex-col md:flex-row md:items-center justify-between">
      {title && <label htmlFor={title} className="font-medium">{title}</label>}
      <select
        value={value}
        name={title}
        id={title}
        className={`
        ${bg ? "bg-gray-100" : "bg-white"}
        border-2 border-black ${width ? width : "md:w-64"} py-1 rounded`}
        onChange={onChange}
      >
        <option value="">Select</option>
        {options?.map((item, index) => (
          <option value={item} key={index}>
            {item}
          </option>
        ))}
      </select>
    </div>
  );
};

export const ModalSelect3 = ({
  title,
  options,
  onChange,
  bg,
  value,
  width,
}) => {
  return (
    <div className="flex gap-3 flex-col md:flex-row md:items-center justify-between">
      {title && <label htmlFor={title} className="font-medium">{title}</label>}
      <select
        value={value}
        name={title}
        id={title}
        className={`
        ${bg ? "bg-gray-100" : "bg-white"}
        border-2 border-black ${width ? width : "md:w-64"} py-1 rounded`}
        onChange={onChange}
      >
        <option value="">Select</option>
        {options?.map((item, index) => (
          <option value={item.value} key={index}>
            {item.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export const ModalSelectAutoComplete = ({
  title,
  options,
  onChange,
  bg,
  value,
  width,
}) => {
  return (
    <div className="flex gap-3 flex-col md:flex-row md:items-center justify-between">
      {title && <label htmlFor={title} className="font-medium">{title}</label>}

      <Autocomplete
        disablePortal
        options={options}
        onChange={(event, newValue) => {
          console.log(newValue);

          onChange(newValue?.value);
        }}
        value={value}
        sx={{
          width: 256,
          "& .MuiOutlinedInput-root": {
            padding: 0,
            border: "2px solid black",
            height: "40px",
            backgroundColor: "white",
          },
          "& .MuiInputBase-input": {
            padding: "8px 12px",
            lineHeight: "1.5",
          },
        }}
        renderInput={(params) => <TextField {...params} sx={{}} />}
      />
    </div>
  );
};

export const ModalSelect2 = ({
  title,
  options,
  onChange,
  bg,
  value,
  width,
}) => {
  return (
    <div className="flex gap-3 flex-col md:flex-row md:items-center justify-between">
      {title && <label htmlFor={title} className="font-medium">{title}</label>}
      <select
        value={value}
        name={title}
        id={title}
        className={`
        ${bg ? "bg-gray-100" : "bg-white"}
        border-2 border-black ${width ? width : "md:w-64"} py-1 rounded`}
        onChange={onChange}
      >
        <option value="">Select</option>
        {options?.map((item, index) => (
          <option value={item.orderIds} key={index}>
            {item.name} ({item.quantity})
          </option>
        ))}
      </select>
    </div>
  );
};

export const ModalDatePicker = ({
  title,
  onChange,
  bg,
  value,
  disabled,
  width,
  pattern,
}) => {
  return (
    <div className="flex gap-1 md:gap-3 md:items-center flex-col md:flex-row justify-between">
      {title && <label htmlFor={title} className="font-medium">{title}</label>}
      <input
        onChange={onChange}
        type="date"
        name={title}
        id={title}
        className={`${bg ? "bg-gray-100" : "bg-white"} border-2 ${
          width ? width : "md:w-64"
        } border-black py-1 px-2 rounded`}
        value={value}
        pattern="\d{4}-\d{2}-\d{2}"
      />
    </div>
  );
};
